import React from 'react';
import { TagBasedAssessment } from '../services/tagBasedScoringService';
import MaturitySpiderChart from './MaturitySpiderChart';
import {
  SparklesIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  DocumentTextIcon
} from '@heroicons/react/24/outline';

interface TagBasedAssessmentProps {
  assessment: TagBasedAssessment;
  showPoints?: boolean;
}

const TagBasedAssessmentComponent: React.FC<TagBasedAssessmentProps> = ({
  assessment,
  showPoints = true
}) => {
  const avgScore = assessment.analysis.dimensionScores.length > 0
    ? assessment.analysis.dimensionScores.reduce((sum, d) => sum + d.percentage, 0) / assessment.analysis.dimensionScores.length
    : 0;

  return (
    <div className="space-y-6">
      {/* Spider Chart */}
      {assessment.analysis.dimensionScores.length > 0 ? (
        <div className="bg-white rounded-lg border border-gray-200 p-6">
          <MaturitySpiderChart
            data={assessment.analysis.dimensionScores}
            title={`${assessment.displayName} by Dimension`}
            size="medium"
            showPoints={showPoints}
          />
        </div>
      ) : (
        <div className="text-center p-6 text-gray-500">
          No data available for this assessment tag.
        </div>
      )}
    </div>
  );
};

export default TagBasedAssessmentComponent;

